import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Martín R.',
  role: 'Corredor',
  location: 'CABA',
  text: 'Cerré 2 ventas más este mes solo por hacer el seguimiento a tiempo. Antes perdía todo en WhatsApp.'
}, {
  name: 'Luciana G.',
  role: 'Agente',
  location: 'Mar del Plata',
  text: 'Súper visual y fácil de usar. Me salvó la vida con los alquileres de temporada.'
}, {
  name: 'Diego F.',
  role: 'Asesor',
  location: 'Córdoba',
  text: 'Tiene justo lo que usamos los asesores. Mejor que cualquier CRM carísimo.'
}, {
  name: 'Valentina M.',
  role: 'Inmobiliaria',
  location: 'Rosario',
  text: 'Ya no me olvido de escribirle a los clientes. La agenda de seguimientos es lo mejor.'
}, {
  name: 'Javier S.',
  role: 'Broker',
  location: 'Mendoza',
  text: 'Sencillo, al grano y efectivo. Si usas WhatsApp todo el día, necesitas esto.'
}];
export function TestimonialsSection() {
  return <section className="py-12 px-4 bg-white" data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-152">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-brand-dark mb-1" data-id="element-153">
            Agentes que ya transformaron su negocio
          </h2>
          <p className="text-gray-500" data-id="element-154">
            Resultados reales de profesionales en Argentina
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-155">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className={`bg-brand-light p-5 rounded-xl border border-gray-100 ${i >= 3 ? 'sm:col-span-1' : ''}`} data-id="element-156">
              <div className="flex gap-0.5 mb-2" data-id="element-157">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-158" />)}
              </div>
              <p className="text-gray-700 italic text-sm mb-3" data-id="element-159">"{t.text}"</p>
              <div className="flex items-center gap-2" data-id="element-160">
                <div className="w-8 h-8 rounded-full bg-brand-dark flex items-center justify-center text-white text-xs font-bold" data-id="element-161">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-162">
                  <p className="font-bold text-brand-dark text-sm" data-id="element-163">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-164">
                    {t.role} · {t.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}